import React from 'react';
import styles from './Logo.module.scss'; // Import CSS module

function Logo() {
  return (
    <div className={styles.logoDesign}> {/* Use unique class name generated by CSS module */}
      <div className={styles.firstDiv}>Space</div>
      <div className={styles.secondDiv}>Park</div>
    </div>
  );
}

export default Logo;
